import { render } from "./BankTransferMerchant.vue?vue&type=template&id=0ec66554&scoped=true&ts=true"
import script from "./BankTransferMerchant.vue?vue&type=script&lang=ts"
export * from "./BankTransferMerchant.vue?vue&type=script&lang=ts"

import "./BankTransferMerchant.vue?vue&type=style&index=0&id=0ec66554&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ec66554"]])

export default __exports__